/**
 * The footer every screen carries.
 *
 * Two jobs, both non-negotiable for a legal product: the practice disclaimer
 * (AI output is a draft, not advice, and a lawyer stays responsible for it) and
 * the copyright line. Keeping them in the shell means no tool page can ship
 * without them, and the wording is changed in exactly one place.
 */
import { Link } from 'react-router-dom';

const LAUNCH_YEAR = 2026;

export function AppFooter() {
  const year = new Date().getFullYear();
  const span = year > LAUNCH_YEAR ? `${LAUNCH_YEAR}–${year}` : `${LAUNCH_YEAR}`;

  return (
    <footer className="app-footer no-print">
      <div className="footer-inner">
        <p className="disclaimer grow">
          <strong>ALFIE assists lawyers; it does not practise law.</strong> Generated research, drafts and
          calculations are starting points that must be verified against the primary sources before they are
          filed, sent or relied on. Using ALFIE does not create an attorney–client relationship.
        </p>
        <nav className="row gap-4 wrap none" aria-label="Footer">
          <Link to="/status">System status</Link>
          <Link to="/contact">Contact</Link>
          <span className="muted-more">© {span} UpLaw</span>
        </nav>
      </div>
    </footer>
  );
}
